module.exports = __webpack_public_path__ + "static/media/map-marker.c570eec1.svg";